<template>
  <div class="page-content">
    <LiveSupportTasks />
    <SupportTeam />
    <OfflineOperators />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, nextTick, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const LiveSupportTasks = defineAsyncComponent(() => import('./LiveAlerts/LiveSupportTasks.vue') as any);
const SupportTeam = defineAsyncComponent(() => import('./LiveAlerts/SupportTeam.vue') as any);
const OfflineOperators = defineAsyncComponent(() => import('./LiveAlerts/OfflineOperators.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const hash = route.hash;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
